export const transmissionTableState = {
  page: 0,
  pageSize: 50,
  totalSelectedRows: 0,
  selectedReports: [],
  searchText: "",
  physiciansFilter: null,
  fetchTableData: false,
  isCacheRefresh: false,
  previousReports: [],
  reportInterval: "3 months",
  useReportIntervalFilter: true,
  selectedRow: null,
};
